// This file was generated by org.multipaz.processor.CodeBuilder, do not edit by hand
package org.multipaz.device

import org.multipaz.cbor.DataItem
import org.multipaz.device.DeviceAttestationSoftware
import org.multipaz.cbor.Cbor
import kotlinx.io.bytestring.ByteString
import org.multipaz.cbor.annotation.CborSerializableGenerated
import org.multipaz.cbor.CborMap
import org.multipaz.crypto.EcPublicKey
import org.multipaz.cbor.Bstr

fun DeviceAttestationSoftware.toCbor(): ByteArray {
    return Cbor.encode(toDataItem())
}

@CborSerializableGenerated(schemaId = "1aYxcuFG5CCVagT9creSLwv3IJ6ZfjTYTpRc8apkyZE")
val DeviceAttestationSoftware_cborSchemaId = ByteString(-43, -90, 49, 114, -31, 70, -28, 32, -107, 106, 4, -3, 114, -73, -110, 47, 11, -9, 32, -98, -103, 126, 52, -40, 78, -108, 92, -15, -86, 100, -55, -111)

fun DeviceAttestationSoftware.Companion.fromCbor(data: ByteArray): DeviceAttestationSoftware {
    return DeviceAttestationSoftware.fromDataItem(Cbor.decode(data))
}

val DeviceAttestationSoftware.Companion.cborSchemaId: ByteString
    get() = DeviceAttestationSoftware_cborSchemaId

fun DeviceAttestationSoftware.toDataItem(): DataItem {
    val builder = CborMap.builder()
    builder.put("type", "Software")
    builder.put("publicKey", this.publicKey.toDataItem())
    val proofOfSecret = this.proofOfSecret
    if (proofOfSecret != null) {
        builder.put("proofOfSecret", Bstr(proofOfSecret.toByteArray()))
    }
    return builder.end().build()
}

fun DeviceAttestationSoftware.Companion.fromDataItem(dataItem: DataItem): DeviceAttestationSoftware {
    val publicKey = EcPublicKey.fromDataItem(dataItem["publicKey"])
    val proofOfSecret0 = if (dataItem.hasKey("proofOfSecret")) {
        dataItem["proofOfSecret"].let { ByteString(it.asBstr) }
    } else {
        null
    }
    return DeviceAttestationSoftware(
        publicKey = publicKey,
        proofOfSecret = proofOfSecret0,
    )
}
